module.exports = __webpack_public_path__ + "static/media/screenshot_selected.71626a7c.svg";